module.exports = __webpack_public_path__ + "img/2-2.785f70f6.png";